import { TmcContextService } from './../../../../common/tmc-context.service';
import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent, AppClientConfigurationService, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { Subscription } from 'rxjs';
import { TerminalContextConstants } from '@sdbn/tmc-common';

import { YardConfiguration } from '../../../../client/model/yard-configuration';
import { TransportOption, TransportOptionColumn, TransportOptionSelection, TransportOptionsPanelModel, TransportOptionsPanelModelUsage } from '../../../../components/transport-options-panel/transport-options-panel.model';
import { RegistrationTransportOption } from '../../../../model/terminal/transport-registration.model';
import { YardPropertiesService } from '../../../../yard-properties.service';

@Component({
    selector: 'app-transport-registration-options',
    templateUrl: './transport-registration-options.component.html',
    styleUrls: ['./transport-registration-options.component.scss'],
    standalone: false
})
export class TransportRegistrationOptionsComponent extends AbstractWidgetComponent implements OnInit {

  model: TransportOptionsPanelModel;
  validStateSubscription: Subscription;
  selectionChangeSubscription: Subscription;

  tmcContextSubscription: Subscription;
  yardConfiguration: YardConfiguration;

  selectedOptions: Array<RegistrationTransportOption>;
  resources = new Array<string>();

  loadingEnabled = false;

  constructor(
      public cps: AppClientConfigurationService,
      private tmcContextService: TmcContextService,
      public yardPropertiesService: YardPropertiesService) {
    super();

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(next => {
      if (next != null) {
        this.yardConfiguration = next;
        this.createTransportOptionsModel();

      }
    });
  }

  ngOnInit(): void {
  }


  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.validStateSubscription != null) {
      this.validStateSubscription.unsubscribe();
      this.validStateSubscription = null;
    }
    if (this.selectionChangeSubscription != null) {
      this.selectionChangeSubscription.unsubscribe();
      this.selectionChangeSubscription = null;
    }
    if (this.tmcContextSubscription != null) {
      this.tmcContextSubscription.unsubscribe();
      this.tmcContextSubscription = null;
    }
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    const selection = this.dashboardContext.getContextValue(TerminalContextConstants.selectedOptions);
    this.selectedOptions = selection == null ? new Array<RegistrationTransportOption>() : selection;
    this.createTransportOptionsModel();
  }

  private createTransportOptionsModel() {

    if (this.validStateSubscription != null) {
      this.validStateSubscription.unsubscribe();
    }
    if (this.selectionChangeSubscription != null) {
      this.selectionChangeSubscription.unsubscribe();
    }

    if (this.yardConfiguration != null && this.selectedOptions != null) {
      let columns = new Array<TransportOptionColumn>();
      for (let option of this.yardConfiguration.transportOptions) {
        while (option.columnIndex != null && columns.length < option.columnIndex + 1) {
          let column = new TransportOptionColumn();
          columns.push(column);
        }
        let column = columns[option.columnIndex];
        const transportOption = new TransportOption(option);
        column.options.push(transportOption);
      }

      const selection = new Array<TransportOptionSelection>();
      let resources = new Array<string>();
      for (const option of this.selectedOptions) {
        const newOption = new TransportOptionSelection(option);
        newOption.selected = true;
        selection.push(newOption);
        /* resourcen anhand selection */
        for (let resourceId of this.getResourcesFromOption(option.transportOptionId)) {
          resources.push(resourceId);
        }
      }
      this.resources = resources;

      this.model = new TransportOptionsPanelModel({ columns: columns, constraints: this.yardConfiguration.transportOptionConstraints, selection: selection, usage: TransportOptionsPanelModelUsage.TERMINAL });
      this.validStateSubscription = this.model.validState.subscribe(valid => {
        this.dashboardContext.setContextValue(TerminalContextConstants.transportOptionsValidityState, valid);
      });

      this.selectionChangeSubscription = this.model.selectionChange.subscribe(value => {

        let resources = new Array<string>();
        const newSelection = new Array<RegistrationTransportOption>();
        for (const selection of this.model.getOnlySelectedTransportOptionSelection()) {
          if (selection.selected) {
            const selectedOption = new RegistrationTransportOption(selection);
            newSelection.push(selectedOption);

            /* resourcen anhand selection */
            for (let resourceId of this.getResourcesFromOption(selection.transportOptionId)) {
              resources.push(resourceId);
            }
          }
        }
        this.resources = resources;
        this.dashboardContext.setContextValue(TerminalContextConstants.selectedOptions, newSelection);
      });

      if(this.yardPropertiesService.isSkipTransportOptionSelectionIfExistsEnabled() && this.selectedOptions.length > 0) {
        this.dashboardContext.setContextValue(TerminalContextConstants.skipTransportOptionSelection, true);
      }

      if(this.yardPropertiesService.isAutoselectSingleTransportoptionEnabled() &&
        this.yardConfiguration.transportOptions.length === 1 && this.model.getOnlySelectedTransportOptionSelection().length === 0) {
        const newSelection = new Array<RegistrationTransportOption>();
        newSelection.push(new RegistrationTransportOption({ transportOptionId: this.yardConfiguration.transportOptions[0].id }));
        this.dashboardContext.setContextValue(TerminalContextConstants.selectedOptions, newSelection);
        this.dashboardContext.setContextValue(TerminalContextConstants.transportOptionsAutoSelect, true);
      }
    }
  }

  getResourcesFromOption(transportOptionId: number): Array<string> {
    let result = new Array<string>();
    for (const option of this.yardConfiguration.transportOptions) {
      if (option.id === transportOptionId) {
        for (const resource of option.resources) {
          result.push(resource);
        }
      }
      for (const childOption of option.transportOptions) {
        if (childOption.id === transportOptionId) {
          for (const resource of childOption.resources) {
            result.push(resource);
          }
        }
      }
    }
    return result;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
